import {eyeOpenSvg as Icon__small__eyeOpenSvg} from '../Icon__small/Icon__small--eyeOpen.js'

export var eyeOpen = {
  name: 'eyeOpen',
  category: 'icon',
  colorable: true,
  svg: Icon__small__eyeOpenSvg,
};
